export default __webpack_public_path__ + "efeb8dbcec23fbe12715748adcbf0efe.png";